import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MxAppInitService, MxIdentityService } from '../services';

@Injectable()
export class MxJwtInterceptor implements HttpInterceptor {
  constructor(
    private identityService: MxIdentityService,
    private appInitService: MxAppInitService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if account is logged in and request is to the api url
    const account = this.identityService.accountValue;
    const isLoggedIn = account && account.jwtToken;
    const isApiUrl =
      !request.url.startsWith('./') ||
      request.url.startsWith(this.appInitService.currentConfig.api.url);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${account.jwtToken}`,
        },
      });
    }

    if (
      request.url.includes('revoke-token') ||
      request.url.includes('authenticate') ||
      request.url.includes('refresh-token')
    ) {
      request = request.clone({
        withCredentials: true,
      });
    }

    return next.handle(request);
  }
}
